<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Suppliers'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Suppliers'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '200px' },
                { value: 'email', width: '200px' },
                { value: 'secondEmail', width: '200px' },
                {
                    value: 'createdAt',
                    filter: 'formatDate',
                    width: '200px',
                    type: 'date'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'suppliers/index',
            deleteItem: 'suppliers/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/suppliers/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/suppliers/add');
        }
    }
};
</script>
